<template>
  <div class="version" v-if="visible" @mousewheel.prevent>
     <div class="version-bg" @click="close"></div>
     <div class="version-body">
       <div class="version-header">
          <span class="">版本更新公告</span>
          <i class="el-icon-close" @click="close"></i>
       </div>
       <div class="version-content">
         <div>
           <span>版本号：{{version}}</span>
           <span>更新时间：{{time}}</span>
        </div>
         <pre v-html="content">
         </pre>
       </div>
       <div class="version-footer">
          <span class="confim-btn"  @click="confirm">我知道了</span>
       </div>
     </div>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      visible: false,
      version: '',
      time: '',
      content: ''
    }
  },
  methods: {
    close () {
      this.visible = false
    },
    confirm () {
      this.visible = false
    },
  },
  components: {

  }
}
</script>

<style lang="scss" scoped>
.version {
  z-index: 2001;
  >div{
   z-index: 2001;
  }
  .version-bg {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }
  >.version-body {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    width: 460px;
    background: #ffffff;
    box-shadow: 0 1px 8px 0 rgba(0,0,0,.18);
    border-radius: 2px;
    .version-header {
      border-bottom: 1px solid rgba(73, 84, 111,0.15);
      height: 52px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      position: relative;
      >span{
        font-size: 18px;
        color: #333333;;
      }
      >i {
        position: absolute;
        right: 20px;
        color: #3D4653;
      }
      .el-icon-close{
        font-size: 16px;
      }
    }
    .version-content {
      text-align: center;
      padding: 34px 61px;
      font-size: 14px;
      color: #666666;
      >:first-child {
        display: flex;
        justify-content: space-between;
      }
      >pre {
        text-align: left;
      }
    }
    .version-footer {
      border-top: 1px solid rgba(73, 84, 111,0.15);
      width: 100%;
      height: 50px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .confim-btn {
        background: #4B7DFE;
        border-radius: 2px;
        color: #ffffff;
        font-size: 12px;
        font-weight: 400;
        height: 28px;
        line-height: 28px;
        padding: 0 11px;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
